import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';

export const dropboxServices = {
    connect,
    auth,
    disconnect,
    getDropboxUserByUserId,
    callSpinriseCamera,
};

function connect(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/dropbox/connect/userId/'+userId, requestOptions)
    .then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));

}

function auth(code, state, userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/dropbox/auth/code/'+ code +'/state/'+state+'/userId/'+userId, requestOptions)
    .then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));

}

function disconnect(userId) {
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userId)
    };

    return fetch(config.apiUrl + '/api/dropbox/disconnect', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getDropboxUserByUserId(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/dropbox/userId/'+userId, requestOptions)
    .then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));

}

function callSpinriseCamera(dropboxToken) {
    const requestOptions = {
        method: 'GET',
        headers: {'Access-Control-Allow-Origin':'*'}
    };

    return fetch('https://spinrisecamera.azurewebsites.net//api/v1/AddDropBoxUserToDB/'+ dropboxToken, requestOptions)
    .then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));

}


// WEBPACK FOOTER //
// ./src/services/dropbox.service.js